"use client";

import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAction } from "next-safe-action/hooks";
import { setUsernameAction } from "@/actions/profile";

interface SaveUsernameInput {
  username: string;
}

export function useSaveUsername() {
  const queryClient = useQueryClient();

  const action = useAction(setUsernameAction, {
    onError({ error }) {
      console.error("Failed to set username", error);
    },
  });

  const mutate = useCallback(
    async (input: SaveUsernameInput) => {
      const result = await action.executeAsync({
        username: input.username,
      });
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["current-profile"], exact: false }),
        queryClient.invalidateQueries({ queryKey: ["profile-settings"], exact: false }),
      ]);
      return result;
    },
    [action, queryClient],
  );

  return {
    mutate,
    isExecuting: action.isExecuting,
  };
}
